import { ERROR_MESSAGE, SAVE_MESSAGE } from 'ds/constants';
import { PartialPick } from 'shared';
import { SnackbarMessage, actions } from 'store/UI';
import { store } from 'store/store';

interface ShowSnackbarProps extends PartialPick<
  SnackbarMessage,
  'duration' | 'negative' | 'link' | 'CTA' | 'img' | 'position' | 'type'
> {
  message?: string;
}

export function showSnackbar({
  duration,
  negative,
  link,
  img,
  CTA,
  position = 'center',
  type = 'dark',
  ...props
}: ShowSnackbarProps | undefined = {}) {
  const message = props.message || (negative ? ERROR_MESSAGE : SAVE_MESSAGE);

  store.dispatch(
    actions.addSnackbarMessage({ value: message, negative: !!negative, duration, link, img, CTA, position, type })
  );
}
